export const theme = {
  colors: {
    primary: '#FF6B6B',
    secondary: '#4ECDC4',
    accent: '#FFE66D',
    background: '#1A1A2E',
    surface: '#16213E',
    text: '#FFFFFF',
    textSecondary: '#A8A8A8',
    error: '#FF6B6B',
    success: '#6BCB77',
    warning: '#FFD93D',
    info: '#4D96FF',
  },
  fonts: {
    primary: '"Press Start 2P", cursive, sans-serif',
    secondary: '"VT323", monospace',
  },
  breakpoints: {
    xs: '320px',
    sm: '576px',
    md: '768px',
    lg: '992px',
    xl: '1200px',
  },
  shadows: {
    small: '0 2px 4px rgba(0, 0, 0, 0.5)',
    medium: '0 4px 8px rgba(0, 0, 0, 0.6)',
    large: '0 8px 16px rgba(0, 0, 0, 0.7)',
  },
  transitions: {
    default: 'all 0.3s ease-in-out',
  },
  // Vintage TV scan lines effect
  scanlines: {
    before: `
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: linear-gradient(
        to bottom,
        rgba(18, 16, 16, 0) 50%,
        rgba(0, 0, 0, 0.25) 50%
      );
      background-size: 100% 4px;
      z-index: 10;
      pointer-events: none;
    `,
    after: `
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: linear-gradient(
        to right,
        rgba(18, 16, 16, 0) 50%,
        rgba(0, 0, 0, 0.1) 50%
      );
      background-size: 4px 100%;
      z-index: 10;
      pointer-events: none;
    `,
  },
  // CRT screen effect
  crtEffect: `
    position: relative;
    overflow: hidden;
    &::before {
      content: " ";
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      background: linear-gradient(rgba(18, 16, 16, 0) 50%, rgba(0, 0, 0, 0.25) 50%);
      background-size: 100% 4px;
      z-index: 10;
      pointer-events: none;
    }
    &::after {
      content: " ";
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      background: linear-gradient(
        to right,
        rgba(18, 16, 16, 0) 50%,
        rgba(0, 0, 0, 0.1) 50%
      );
      background-size: 4px 100%;
      z-index: 10;
      pointer-events: none;
    }
  `,
};
